/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  LoadingContentPlugin,
  ILoadingContentPluginMethods,
  ErrorContentPlugin,
  IErrorContentPluginMethods,
  StaticContentPlugin,
  IStaticContentPluginMethods,
  LandingPageDataService,
  ILandingPageDataMethods,
  HeaderNavItemsPlugin,
  IHeaderNavItemsPluginMethods,
} from './plugins';

export type TAgent = IStaticContentPluginMethods &
  ILoadingContentPluginMethods &
  IErrorContentPluginMethods &
  ILandingPageDataMethods &
  IHeaderNavItemsPluginMethods;

const getPlugins = () => {
  return [
    new StaticContentPlugin(),
    new ErrorContentPlugin(),
    new LoadingContentPlugin(),
    //Business logic plugins !
    new LandingPageDataService(),
    new HeaderNavItemsPlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
